import { render, staticRenderFns } from "./talent_recruitment.vue?vue&type=template&id=28acc8da&scoped=true"
import script from "./talent_recruitment.vue?vue&type=script&lang=js"
export * from "./talent_recruitment.vue?vue&type=script&lang=js"
import style0 from "./talent_recruitment.vue?vue&type=style&index=0&id=28acc8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28acc8da",
  null
  
)

export default component.exports